import React from 'react';
import { useOrionUI } from 'src/common/hooks/useOrionUI';
import { PageHeaderOrion } from './PageHeaderOrion';
import { PageHeaderClassic } from './PageHeaderClassic';

export interface PageHeaderProps {
  title?: string;
  subtitle?: string;
  description?: string;
}

export const PageHeader: React.FC<PageHeaderProps> = (props) => {
  return useOrionUI() ? <PageHeaderOrion {...props} /> : <PageHeaderClassic {...props} />;
};
